<template>
    <div class="loginPage">
        <el-row>
            <el-col :scope="24">
                <div class="login_welcome_wrapper">
                    <p> Enter your email to reset your password </p>
                </div>
            </el-col>
        </el-row>
        <el-form>
            <el-row>
                <el-col :span="6" :offset="9">
                    <div class="input-login-data" style="margin-left: 30px; margin-right: 30px;">
                        <el-form-item label="">
                            <el-input v-model="email" type="text" placeholder="Email"/>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="9">
                    <div class="login_welcome_wrapper" style="text-align: right; margin-right: 30px;">
                        <div class="send-button-box">
                            <el-form-item label="">
                                <el-button type="primary" @click="onSubmit">Send</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <el-row>
            <el-col :scope="24">
                <div class="login_welcome_wrapper">
                    <div class="back_to_login">
                        <a href="/#/console/login">Go to Login</a>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>

import { Message } from 'element-ui';

export default {
    data() {
        return {
            email: ""
        }
    },
    methods: {
        onSubmit() {
            console.log("send code")
            Message.success({message: "Please check your email to get the password"})
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue